export function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 403) {
                return Promise.reject('You are not authorised to perform this action');
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (!data.success) {
            const error = (data && data.message) || 'An error occurred';
            return Promise.reject(error);
        }
        return Promise.resolve(data);
    });
}
